<template>
    <div id="search-profile-page">
        <div class="fields">
            <ui5-input
                :value="code"
                @input="code = $event.target.value"
                @keyup.enter="search"
                :placeholder="trans('pages.search_profile.profile_code')"
            />
            <ui5-input
                :value="description"
                @input="description = $event.target.value"
                @keyup.enter="search"
                :placeholder="trans('pages.search_profile.description')"
            />
            <ui5-button @click="search">
                {{ trans('pages.search_profile.search') }}
            </ui5-button>
        </div>
        <spinner-text v-if="loading">
            {{ trans('pages.search_profile.searching_profiles') }}
        </spinner-text>
        <ul v-if="profiles">
            <li
                v-for="profile in profiles"
                :key="profile.ID"
            >
                {{ profile.code }}, {{ profile.description }}
            </li>
        </ul>
    </div>
</template>
<style scoped>
.fields {
    display: flex;
    gap: 12px;
}
</style>
<script>
import profileApi from '../api/profile';
import SpinnerText from '../components/loader/SpinnerText';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { SpinnerText },
    mixins: [localization],
    mounted() {},
    data() {
        return {
            loading: false,
            code: '',
            description: '',
            profiles: null,
        };
    },
    methods: {
        search() {
            this.loading = true;
            profileApi
                .list(this.code, this.description)
                .then((response) => {
                    this.profiles = response.data.data;
                    this.code = '';
                    this.description = '';
                })
                .catch(() => {
                    showErrorMessage(
                        this.trans('pages.search_profile.search_failed')
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
